import ModelDelete from "@/pages/modals/_delete";
import { useDeleteHouseRentalMutation } from "@/services/house-rental.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function DeleteHouseRental() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteHouseRental, {isSuccess}] = useDeleteHouseRentalMutation()

    const onAccept = () => {
        deleteHouseRental(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_house_rental")} content={t("modal.delete_house_rental_content")} onAccept={onAccept} />
}